import React from "react";
import { Heading, Flex, Card, Button, Box } from "theme-ui";

import { Icon } from "./Icon";
import { lightGray } from "src/styles/colors"

type DialogIntent = "success" | "warning" | "danger" | "info";

type DialogProps = {
  intent?: DialogIntent;
  title: string;
  icon?: React.ReactNode;
  cancelLabel?: string;
  onCancel: () => void;
};

const iconFromIntent = (intent: DialogIntent | undefined) => {
  switch (intent) {
    case "success":
      return <Icon name="check-circle" color="success" aria-label="Success" />;
    case "warning":
      return <Icon name="exclamation-triangle" color="warning" aria-label="Warning" />;
    case "danger":
      return <Icon name="exclamation-triangle" color="danger" aria-label="Danger" />;
    case "info":
      return <Icon name="info-circle" color="info" aria-label="Info" />;
  }
  return null;
};

export const Dialog: React.FC<DialogProps> = ({
  intent,
  title,
  icon,
  cancelLabel,
  onCancel,
  children
}) => (
  <div className="rounded-lg bg-component">
    {intent ? <Box sx={{ height: "4px", bg: intent, borderRadius: "3px 3px 0 0" }} /> : null}
    <div
      className="flex flex-row justify-between items-center border-b border-clearWhite pt-8 px-6 pb-6 text-style-desc">
      {icon || iconFromIntent(intent)}
      <Heading as="h1" sx={{ textAlign: "center", fontSize: [2, 3], px: [3, 0] }}>
        {title}
      </Heading>
      <Button
        variant="icon"
        sx={{color: 'white'}} onClick={onCancel}>
        <Icon name="times" size="lg" aria-label={cancelLabel || "Cancel"} />
      </Button>
    </div>
    {children}
  </div>
);
